import { render, staticRenderFns } from "./file-upload-widget.vue?vue&type=template&id=c1442d0e&scoped=true&"
import script from "./file-upload-widget.vue?vue&type=script&lang=js&"
export * from "./file-upload-widget.vue?vue&type=script&lang=js&"
import style0 from "./file-upload-widget.vue?vue&type=style&index=0&id=c1442d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1442d0e",
  null
  
)

export default component.exports